import { AppConfig, BuildConfig } from "@/lib/nemmp/app-config/types";
import { providerConfig } from "@/modules/legal/providers/providerConfig";

export function buildAppConfig(
  buildConfig: BuildConfig,
  overrides: Partial<AppConfig> = {},
): AppConfig {
  const devprod = <T,>(devValue: T, prodValue: T): T => {
    const isProd =
      process.env["NODE_ENV"] === "production" &&
      buildConfig.env === "production";
    return isProd ? prodValue : devValue;
  };

  const mainWebOnly = <T,>(value: T): T | undefined => {
    if (buildConfig.platform === "web" && buildConfig.inst === "main") {
      return value;
    }
    return undefined;
  };

  const rootUrl = process.env["NEXT_PUBLIC_ROOT_URL"];
  if (!rootUrl) {
    throw new Error("NEXT_PUBLIC_ROOT_URL is not set");
  }

  const host = rootUrl.split("://")[1];

  const apiBaseUrl = process.env["NEXT_PUBLIC_API_BASE_URL"];
  if (!apiBaseUrl) {
    throw new Error("NEXT_PUBLIC_API_BASE_URL is not set");
  }

  return {
    name: "scriptea",
    code: "scriptea",
    version: buildConfig.version,
    websiteUrl: rootUrl,
    apiBaseUrl: rootUrl,
    host: host,
    https: rootUrl.startsWith("https://"),
    // Plausible only when env allows metrics and privacy policy permits the provider.
    plausible: mainWebOnly({
      enabled: devprod(false, true) && providerConfig.plausible.enabled,
    }),
    apiUrl: apiBaseUrl,
    buildConfig,
    ...overrides,
  };
}
